import { render, staticRenderFns } from "./second-step.html?vue&type=template&id=23e97618&scoped=true&external"
import script from "./second-step.js?vue&type=script&lang=js&external"
export * from "./second-step.js?vue&type=script&lang=js&external"
import style0 from "./second-step.scss?vue&type=style&index=0&id=23e97618&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e97618",
  null
  
)

export default component.exports